export const ANDROID_PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.ufirstgroup.FavurApp'
export const IOS_APP_STORE_LINK = 'https://apps.apple.com/us/app/favur/id1523448084'
